var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine360 = function SvgLandingLine360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 1222,
    fill: "none",
    className: "landing-line-360_svg__landing-line-360"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.563,
    d: "M226 0v40.11c0 35.563-27.784 64.93-63.292 66.898l-89.916 4.984C37.284 113.96 9.5 143.327 9.5 178.889v105.958c0 35.332 27.438 64.592 62.697 66.861l84.606 5.445c35.259 2.269 62.697 31.529 62.697 66.862v100.074c0 35.339-27.448 64.603-62.715 66.863l-93.07 5.964C28.448 599.177 1 628.44 1 663.779v128.174c0 36.106 28.61 65.718 64.695 66.961l95.61 3.291C197.39 863.447 226 893.059 226 929.165v68.692c0 35.443-27.598 64.753-62.972 66.883l-99.056 5.96C28.598 1072.83 1 1102.14 1 1137.58V1222"
  })));
};
export default SvgLandingLine360;